import React from "react";

export function MandatoryStar() {

    return (<span style={{ color: "red", marginTop: "-3px", float: "right" }}>*</span>
    )
}

export default MandatoryStar;